import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { MyDepositPlanAccount } from '../../.types/interfaces/my-deposit-plan-account';

@Injectable({ providedIn: 'root' })
export class CinchService {
  public accounts: MyDepositPlanAccount[] = [];
  public selectedAccount!: MyDepositPlanAccount;

  constructor(private http: HttpClient) { 

  }

  public hasSelectedAccount() {
    if (this.selectedAccount && Object.keys(this.selectedAccount).length > 0) {
      return true;
    }
    else {
      return false;
    }
  }

  public getSelectedAccount() {
    return this.selectedAccount;
  }

  setSelectedAccount(account: MyDepositPlanAccount) {
    this.selectedAccount = account;
  }

  loadAccountsObservable(username: string): Observable<any[]> {
    const params = new HttpParams()
      .set('username', username)
      .set('viewname', 'my-deposit-plan');
    const results = this.http.get<any[]>('/api/cinchusers', {params: params});
    return results;
  }

  loadTransactionsObservable(username: string, savid: string): Observable<any[]> {
    const params = new HttpParams()
      .set('username', username)
      .set('savid', savid);
    const results = this.http.get<any[]>('/api/cinchtransactions', {params: params});
    return results;
  }

  sendEmailNotification(type: string, fromaccount: string, toaccount: string, deliverymethod: string, pickupdate: string, pickuptime: string, amount: string, comments: string, username: string) {
    const bodyParams = {
      'type': type,
      'fromaccount': fromaccount,
      'toaccount': toaccount,
      'deliverymethod': deliverymethod,
      'pickupdate': pickupdate,
      'pickuptime': pickuptime,
      'amount': amount,
      'comments': comments
    };
    const params = new HttpParams()
      .set('username', username);
    var request = this.http.post('/api/emailnotification', bodyParams, {params: params});
    return request;
  }

  sendEmailPayment(
    fromaccount: string,
    amount: string,
    paydate: string,
    invoices: any[],
    username: string,
    paymentoption: string,
    internal: boolean){
    
    const eventBody = {
      username: username,
      fromaccount: fromaccount,
      amount: amount,
      paydate: paydate,
      paymentoption: paymentoption,
      internal: internal,
      body: JSON.stringify({
        invoices: invoices
      })
    };

    const params = new HttpParams().set('username', username);

    var request = this.http.post('/api/emailnotification', eventBody, {params: params});

    return request;
}

  sendEmailPaymentConfirmationToUser(
    userEmail: string,
    username: string,
    fromaccount: string,
    accountName: string,
    accountNumber: string,
    amount: string,
    paydate: string,
    invoices: any[],
    paymentoption: string,
    internal: boolean) {

    const eventBody = {
      sendToUser: true,
      userEmail: userEmail,
      username: username,
      fromaccount: fromaccount,
      accountName: accountName,
      accountNumber: accountNumber,
      amount: amount,
      paydate: paydate,
      paymentoption: paymentoption,
      internal: internal,
      body: JSON.stringify({
        invoices: invoices
      })
    };

    const params = new HttpParams().set('username', username);

    var request = this.http.post('/api/emailnotification', eventBody, { params: params });

    return request;
  }

  public reset() {
    this.accounts = [];
    this.selectedAccount = {} as MyDepositPlanAccount;
  }
}